"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const useSticky_1 = __importDefault(require("../useSticky/useSticky"));
const useWindowSize_1 = __importDefault(require("../useWindowSize"));
const Container = styled_1.default("div") `
  position: ${({ position }) => position};
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  width: 256px;
  max-height: 90vh;
  overflow: hidden;
  z-index: ${({ theme }) => theme.zIndex.selectOptions + 1};
  display: flex;
  flex-direction: column;
`;
const ScrollTrap = styled_1.default("div") `
  max-height: 50vh;
  overflow: auto;
`;
exports.SidenavPopout = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const $container = React.useRef(null);
    const [initialTop, setInitialTop] = React.useState("0");
    const { height } = useWindowSize_1.default();
    React.useLayoutEffect(() => {
        const node = $container.current;
        if (node) {
            const rect = node.getBoundingClientRect();
            // If we're in the lower half of the screen
            if (rect.top > height / 2) {
                // open towards the top
                setInitialTop(`${rect.top - (rect.height - (node.parentElement ? node.parentElement.clientHeight : 0))}px`);
            }
            else {
                setInitialTop(`${rect.top}px`);
            }
        }
    }, [height]);
    const { left, position } = useSticky_1.default({ $el: $container });
    return (React.createElement(Container, Object.assign({}, props, { position: position, top: initialTop, left: left, ref: $container }),
        React.createElement(ScrollTrap, null, children)));
};
exports.default = exports.SidenavPopout;
//# sourceMappingURL=Popout.js.map